/* PDP description "Read more" — collapses a long product description on mobile
   only, and reveals a toggle when the copy actually overflows. Progressive
   enhancement: with JS off, the full description renders (no collapse). */
(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var COLLAPSED_MAX_PX = 210; // ~12.5em; below this, no toggle is needed

  function setup(wrap) {
    var desc = wrap.querySelector('.product__description');
    var btn = wrap.querySelector('.product__description-toggle');
    if (!desc || !btn) return;

    function evaluate() {
      if (!MOBILE.matches) {
        wrap.classList.remove('is-collapsible', 'is-expanded');
        btn.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        return;
      }
      // Measure the un-clamped height.
      wrap.classList.remove('is-collapsible');
      var fullHeight = desc.scrollHeight;
      if (fullHeight > COLLAPSED_MAX_PX) {
        wrap.classList.add('is-collapsible');
        btn.hidden = false;
      } else {
        wrap.classList.remove('is-expanded');
        btn.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      }
    }

    btn.addEventListener('click', function () {
      var expanded = wrap.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    evaluate();
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', evaluate);
    else if (MOBILE.addListener) MOBILE.addListener(evaluate);

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(evaluate, 200);
    });
  }

  function init() {
    var wraps = document.querySelectorAll('[data-description-collapse]');
    for (var i = 0; i < wraps.length; i++) setup(wraps[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
